// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submenuMain
{
    width: 100%;
    height: 100%;
    
}

.submenuTitle
{
    width: 96%;
    margin-top: 4px;
    margin-left: 1%;
    margin-right: 1%;
    margin-bottom: 8px;
    background-color: transparent;
    border-radius: 3px;
    color: white;
    height: 20px;
    font-size: 15px;


}

.submenuCurrentDiv
{
    width: 100%;
    height: calc(100% - 20px - 32px - 12px);
    padding-left: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Firefox */
    scrollbar-width: none;

    /* Internet Explorer / ancien Edge */
    -ms-overflow-style: none;    
    
    
}

/* Chrome, Edge, Safari */
.submenuCurrentDiv::-webkit-scrollbar {
    display: none;
}

.submenuBottom
{
    width: 100%;
    height: 32px;
    
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/submenudialogs/submenus.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;;AAEhB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;;;AAGnB;;AAEA;;IAEI,WAAW;IACX,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;;IAErB,oCAAoC;IACpC,wBAAwB;;;AAG5B;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,YAAY;;AAEhB","sourcesContent":[".submenuMain\n{\n    width: 100%;\n    height: 100%;\n    \n}\n\n.submenuTitle\n{\n    width: 96%;\n    margin-top: 4px;\n    margin-left: 1%;\n    margin-right: 1%;\n    margin-bottom: 8px;\n    background-color: transparent;\n    border-radius: 3px;\n    color: white;\n    height: 20px;\n    font-size: 15px;\n\n\n}\n\n.submenuCurrentDiv\n{\n    width: 100%;\n    height: calc(100% - 20px - 32px - 12px);\n    padding-left: 10px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    /* Firefox */\n    scrollbar-width: none;\n\n    /* Internet Explorer / ancien Edge */\n    -ms-overflow-style: none;    \n    \n    \n}\n\n/* Chrome, Edge, Safari */\n.submenuCurrentDiv::-webkit-scrollbar {\n    display: none;\n}\n\n.submenuBottom\n{\n    width: 100%;\n    height: 32px;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
